import useOnHeaderFooterUpdate from './useOnHeaderFooterUpdate';

export default useOnHeaderFooterUpdate;